var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanBlack24Dp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 26.5H25.25V18.625H21.875V14.125H16.25V11.875H19.625V4H10.625V11.875H14V14.125H8.375V18.625H5V26.5H14V18.625H10.625V16.375H19.625V18.625H16.25V26.5Z",
    fill: "#019FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanBlack24Dp1);
export default __webpack_public_path__ + "static/media/lan_black_24dp_1.ae4e5c3985671b0e99da0b916e3ecabf.svg";
export { ForwardRef as ReactComponent };